module.exports = __webpack_public_path__ + "img/mechanism.86e06c4a.png";